/*
 * Pick-N-pay-for-M set picker ("buy 1 get 2 free", "buy 2 get 1 free", ...).
 * The shopper fills N slots from one grid of products (deepest stock first). The M priciest picks are paid
 * (optionally capped), the rest are free. The discount Function's "pay-priciest" mode does the same maths at
 * checkout for every cart line that carries the page's offer property, so the page price = the checkout price.
 *
 * Everything brand- or offer-specific comes from the markup, never from this file:
 *   root [data-fw]: data-set-size (N, default 3) · data-paid (M, default 1) · data-cap (optional, store currency)
 *                   data-offer-key · data-offer-prop (line property name, e.g. _blessac_offer)
 *                   data-first-mobile / data-first-desktop (cards before "Show more", default 9 / 8)
 *   <script type="application/json" data-fw-pool>  {"kinds":[...], "items":[...]}  (rendered by the section)
 *       kind: {key, label, short?, facts?, sheet?, shot?, chip?}   item: {id, n, kind, price, img, imgs[], note, stock}
 *   <script type="application/json" data-picker-text>  overrides for TEXT below (copy, labels, plurals)
 *   window.PICKER_ADD(lines, sourceEl) -> Promise   optional theme cart adapter (see cart-adapter-horizon.liquid);
 *       without it: POST /cart/add.js, then the Broadcast-style drawer events, else go to /cart.
 * Copy that lands in JS strings uses curly quotes only (a straight ' once broke a live page for 7 hours).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-fw]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var readJson = function (sel) { try { var el = $(sel); return el ? JSON.parse(el.textContent || '{}') : {}; } catch (e) { return {}; } };

  var TEXT = Object.assign({
    all: 'All', free: 'FREE', freeBadge: 'Free', viewDetails: 'View details ›', showMore: 'Show {n} more designs',
    low: 'Only {n} left', onlyLeft: 'Only {n} left in {name}.',
    slotPaid: 'Pick {i}', slotFree: 'Free pick {i}',
    rowPaid: 'Your pick {i}', rowFree: 'Free pick {i}', rowHint: 'Tap a design above',
    needMore: 'Pick {n} more.', full: 'All {set} picked. Tap another design to swap out your first pick.', swapped: 'Swapped {from} for {to}.', finish: 'Pick {n} more to finish your set.',
    ctaMore: 'Pick {n} more', ctaAdd: 'Add to cart', adding: 'Adding your set…',
    stickyStart: 'Choose {set}', stickyMore: 'Pick {n} more', stickyPrice: '{set} for {price}', stickyPay: 'You pay {price}',
    stickySubEmpty: 'Pick any {set}. Pay for {paid}.',
    added: 'Your set is in the cart. Want more? Pick {set} more.',
    sheetAdd: 'Add to my {set}', sheetFull: 'Swap for my first pick', swipe: 'Swipe for more photos ›',
    hint: 'Tap a design to add it. {free} of your {set} are free.', tip: 'Pick any {set}. Pay for {paid}.', group: '{n} designs', allDesigns: 'Every design on this page is in the sale.', allSame: 'All {set} are {name} already.', tierPrice: '{n} for {price}', tierOff: 'Extra {off} off', tierCount: '{n} wallets', stepTitle: 'Choose your {set} wallets', stepPaid: 'Pay for {paid}',
    rhead: '{set} wallets · pay for {paid}',
    bonusRow: 'Extra savings for {set}', bonusOn: 'Applied to your set', bonusWhen: 'When all {set} are picked',
    upTitle: 'Add {n} more: get {total} wallets', upSub: 'Pay for {paid} of {total}, {price} total', upDone: 'Now pick {set}. Your wallets are kept.',
    errStock: '{msg} Please choose another design.', err: 'Something went wrong. Please try again.',
    overTitle: 'This offer has ended.', overBody: 'Thank you for being part of it.', overLink: 'See all designs', overUrl: '/collections/all',
    // Rolling "ends this Sunday" (US Eastern). Delete the [data-fw-ends] elements from the markup to turn it off.
    endsHero: 'Offer ends this Sunday, {date}', endsHeroToday: 'Offer ends today, Sunday, {date}',
    endsNote: 'Offer ends Sunday, {date}.', endsNoteToday: 'Offer ends tonight (Sunday, {date}).',
    moreReviews: 'Show more reviews'
  }, readJson('[data-picker-text]'));
  // The ad's UTM tags, kept for the session (first ad click wins) so a shopper who browses before buying still counts.
  var UTM = (function () {
    var keys = ['source', 'campaign', 'content'], fromUrl = {}, stored = {};
    try { var q = new URL(window.location.href).searchParams; keys.forEach(function (k) { var v = q.get('utm_' + k); if (v) fromUrl[k] = v.slice(0, 120); }); } catch (e) {}
    try { stored = JSON.parse(sessionStorage.getItem('blessac_utm') || '{}') || {}; } catch (e) {}
    if (!stored.source && fromUrl.source) { stored = fromUrl; try { sessionStorage.setItem('blessac_utm', JSON.stringify(stored)); } catch (e) {} }
    return stored.source ? stored : fromUrl;
  })();
  var t = function (key, vars) {
    vars = vars || {};
    if (vars.n !== undefined && vars.s === undefined) vars.s = Number(vars.n) === 1 ? '' : 's';
    return String(TEXT[key] == null ? key : TEXT[key]).replace(/\{(\w+)\}/g, function (m, k) { return vars[k] == null ? m : vars[k]; });
  };

  (function endsThisSunday() {
    var els = $$('[data-fw-ends]');
    if (!els.length || !window.Intl) return;
    var now = {};
    try {
      new Intl.DateTimeFormat('en-US', {timeZone: 'America/New_York', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric'})
        .formatToParts(new Date()).forEach(function (p) { now[p.type] = p.value; });
    } catch (e) { return; }
    var dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(now.weekday);
    if (dow < 0) return;
    var ahead = (7 - dow) % 7;
    var date = new Date(Date.UTC(Number(now.year), Number(now.month) - 1, Number(now.day) + ahead))
      .toLocaleDateString('en-US', {timeZone: 'UTC', month: 'short', day: 'numeric'});
    els.forEach(function (el) {
      var which = el.getAttribute('data-fw-ends') === 'hero' ? 'endsHero' : 'endsNote';
      el.textContent = t(ahead === 0 ? which + 'Today' : which, {date: date});
    });
  })();

  var SET = Math.max(1, parseInt(root.getAttribute('data-set-size'), 10) || 3);
  var PAID = Math.min(SET, Math.max(1, parseInt(root.getAttribute('data-paid'), 10) || 1));
  var CAP = parseFloat(root.getAttribute('data-cap')) || Infinity;
  var OFFER_KEY = root.getAttribute('data-offer-key') || '';
  var OFFER_PROP = root.getAttribute('data-offer-prop') || '_offer';
  var IS_PROTOTYPE = !window.Shopify || root.hasAttribute('data-fw-prototype');
  var LOW = 10;
  var tv = {set: SET, paid: PAID};
  // Offer tiers (buy 1 get 2 / buy 2 get 4 / buy 3 get 6): [{n, paid, off, cap?, title, sub, badge?}].
  var TIERS = []; try { TIERS = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { TIERS = []; }
  var OFF = 0, TIER = 0;

  var data = readJson('[data-fw-pool]');
  var kinds = {};
  (data.kinds || []).forEach(function (k) { kinds[k.key] = k; });
  var kindOf = function (p) { return kinds[p.kind] || {key: p.kind || 'item', label: ''}; };
  // Kinds in config order (all Wallets, then all Mini Wallets); inside each kind the deepest stock leads.
  var kindRank = {};
  (data.kinds || []).forEach(function (k, i) { kindRank[k.key] = i; });
  var items = (data.items || []).filter(function (p) { return p && p.id && p.img; })
    .sort(function (a, b) {
      return ((kindRank[a.kind] || 0) - (kindRank[b.kind] || 0)) || ((b.stock || 0) - (a.stock || 0)) || String(a.n).localeCompare(String(b.n));
    });
  if (!items.length) {
    var pickBox = $('.a__pick');
    if (pickBox) pickBox.innerHTML = '<div class="fw__over"><p class="fw__over-t">' + t('overTitle') + '</p><p>' + t('overBody') +
      '</p><a class="fw__atc" href="' + t('overUrl') + '">' + t('overLink') + '</a></div>';
    var stk = $('[data-fw-sticky]'); if (stk) stk.remove();
    return;
  }

  var money = function (n) { return '$' + n.toFixed(2); };
  var moneyShort = function (n) { return n % 1 === 0 ? '$' + n : money(n); }; // $10 rather than $10.00
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  };
  var sized = function (url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var shot = function (p, w, lazy) {
    var k = kindOf(p);
    return '<span class="fw__shot' + (k.shot ? ' ' + k.shot : '') + '"><img src="' + esc(sized(p.img, w)) +
      '" alt="" width="600" height="800"' + (lazy ? ' loading="lazy"' : '') + ' decoding="async"></span>';
  };
  var label = function (p) { var k = kindOf(p); return p.n + (k.label ? ' ' + k.label : ''); };
  var shortName = function (p) { var k = kindOf(p); return p.n + (k.short ? ' ' + k.short : ''); };
  var TOP = items.map(function (p) { return p.price; }).sort(function (a, b) { return b - a; });
  // Most a full set of this tier costs (priciest designs), after the tier's extra savings.
  var tierPrice = function (tr) {
    var top = Math.min(tr.cap || Infinity, TOP.slice(0, tr.paid).reduce(function (s, x) { return s + x; }, 0));
    return Math.max(0, top - (tr.off || 0));
  };
  var bestSetPrice = function () { return tierPrice({paid: PAID, cap: CAP, off: OFF}); };

  var wideMq = window.matchMedia('(min-width:760px)');
  var firstCount = function () {
    return parseInt(root.getAttribute(wideMq.matches ? 'data-first-desktop' : 'data-first-mobile'), 10) || (wideMq.matches ? 8 : 9);
  };
  var FIRST = firstCount();
  var st = {picks: [], filter: 'all', showAll: false, busy: false, msg: '', warn: false};
  function applyTier(i) {
    var tr = TIERS[i]; if (!tr) return;
    TIER = i; SET = tr.n; PAID = tr.paid; OFF = tr.off || 0; CAP = tr.cap || Infinity;
    tv.set = SET; tv.paid = PAID;
    // Going down a tier keeps the shopper's last picks (same rule as a swap).
    if (st.picks.length > SET) st.picks = st.picks.slice(st.picks.length - SET);
  }
  applyTier(Math.max(0, Math.min(TIERS.length - 1, parseInt(root.getAttribute('data-tier-start'), 10) || 0)));

  var countOf = function (p) { return st.picks.filter(function (x) { return x === p; }).length; };
  // Receipt order = checkout order: priciest first (those are paid); ties keep the order they were picked.
  var ordered = function () {
    return st.picks.map(function (p, i) { return {p: p, i: i}; })
      .sort(function (a, b) { return b.p.price - a.p.price || a.i - b.i; })
      .map(function (x) { return x.p; });
  };
  var filtered = function () {
    return st.filter === 'all' ? items : items.filter(function (p) { return p.kind === st.filter; });
  };
  var priceOf = function (picks) {
    var paid = picks.slice(0, PAID).reduce(function (s, p) { return s + p.price; }, 0);
    // The tier's extra savings come off once the set is complete.
    return Math.max(0, Math.min(paid, CAP) - (picks.length >= SET ? OFF : 0));
  };
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  // Filter chips: built from the kinds present in the pool; hidden when there is only one kind.
  (function chips() {
    var box = $('[data-b3-chips]');
    if (!box) return;
    var present = Object.keys(kinds).filter(function (k) { return items.some(function (p) { return p.kind === k; }); });
    if (present.length < 2) { box.hidden = true; return; }
    box.innerHTML = '<button type="button" data-b3-filter="all" aria-pressed="true">' + esc(t('all')) + '</button>' +
      present.map(function (k) {
        return '<button type="button" data-b3-filter="' + esc(k) + '" aria-pressed="false">' + esc(kinds[k].chip || kinds[k].label) + '</button>';
      }).join('');
  })();

  function card(p) {
    var i = items.indexOf(p), n = countOf(p), k = kindOf(p);
    return '<div class="fw__vcard" data-b3-i="' + i + '" data-on="' + (n > 0) + '">' +
      '<button type="button" class="fw__vcard-pick" data-pick-only aria-label="' + esc(label(p)) + '">' +
      shot(p, window.innerWidth >= 760 ? 300 : 240, true) +
      (n ? '<span class="b3__cnt" aria-hidden="true">' + (n > 1 ? '×' + n : '✓') + '</span>' : '') +
      (p.stock && p.stock <= LOW ? '<span class="b3__low">' + esc(t('low', {n: p.stock})) + '</span>' : '') +
      '<span class="fw__vcard-n">' + esc(p.n) + '</span>' +
      '<span class="fw__vcard-p">' + (k.label ? '<span class="b3__kind">' + esc(k.label) + '</span>' : '') + money(p.price) + '</span></button>' +
      '<button type="button" class="fw__vcard-detl" data-lens aria-label="' + esc(t('viewDetails') + ' ' + label(p)) + '">' + esc(t('viewDetails')) + '</button></div>';
  }

  function render() {
    var list = filtered();
    // Only "All" opens short; a chip is the shopper asking for that kind, so it shows every design of it.
    var visible = st.showAll || st.filter !== 'all' ? list : list.slice(0, FIRST);
    var grid = $('[data-b3-grid]');
    if (grid) {
      // One heading per kind, so a shopper scrolling a long grid always knows which wallet and price this is.
      var lastKind = null;
      grid.innerHTML = visible.map(function (p) {
        var head = '';
        if (p.kind !== lastKind) {
          lastKind = p.kind;
          var kk = kindOf(p), same = list.filter(function (x) { return x.kind === p.kind; });
          head = '<h3 class="b3__grp"><span>' + esc((kk.label || '') + 's') + '</span><span>' + esc(t('group', {n: same.length, price: money(p.price)})) + '</span></h3>';
        }
        return head + card(p);
      }).join('');
    }
    var more = $('[data-fw-more]');
    if (more) {
      var hidden = list.length - visible.length;
      more.hidden = hidden <= 0;
      if (!more.hidden) {
        // Says what is behind the button, so the shopper knows the Mini Wallets are in there.
        var rest = list.slice(visible.length);
        var parts = (data.kinds || []).map(function (k) {
          var c = rest.filter(function (x) { return x.kind === k.key; }).length;
          return c ? c + ' ' + k.label + (c === 1 ? '' : 's') : '';
        }).filter(Boolean);
        more.innerHTML = '<span class="b3__more-tx"><span class="b3__more-t">' + esc(t('showMore', {n: hidden})) + '</span>' +
          '<span class="b3__more-s">' + esc(parts.join(' and ')) + '</span></span>' +
          '<span class="b3__more-i" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></span>';
      }
    }
    $$('[data-b3-filter]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-b3-filter') === st.filter)); });

    var tiersBox = $('[data-b3-tiers]');
    if (tiersBox && TIERS.length > 1) {
      tiersBox.hidden = false;
      tiersBox.innerHTML = TIERS.map(function (tr, i) {
        // List row: radio, offer, '6 wallets' + extra-savings pill (deeper yellow on the top tier), price.
        var hot = i === TIERS.length - 1;
        return '<button type="button" class="b3__tr' + (i === TIER ? ' is-on' : '') + '" data-b3-tier="' + i + '" aria-pressed="' + (i === TIER) + '">' +
          '<span class="b3__tr-dot" aria-hidden="true"></span><span class="b3__tr-mid"><span class="b3__tr-t">' + esc(tr.title) + '</span>' +
          '<span class="b3__tr-s">' + esc(t('tierCount', {n: tr.n})) +
          (tr.off ? '<span class="b3__tr-tag' + (hot ? ' b3__tr-tag--hot' : '') + '">' + esc(t('tierOff', {off: moneyShort(tr.off)})) + '</span>' : '') +
          '</span></span><span class="b3__tr-p">' + money(tierPrice(tr)) + '</span></button>';
      }).join('');
    }
    setText('[data-b3-step]', t('stepTitle', tv));
    setText('[data-b3-step-p]', t('stepPaid', tv));
    setText('[data-b3-rhead]', t('rhead', tv));
    setText('[data-b3-hint]', t('hint', {set: SET, free: SET - PAID}));
    var picks = ordered(), n = picks.length, left = SET - n;
    var freshAt = st.fresh ? picks.lastIndexOf(st.fresh) : -1; // slot that just changed: highlight it
    var slots = $('[data-b3-slots]');
    var pinSlots = $('[data-b3-pin-slots]');
    if (slots) {
      var out = '';
      for (var k = 0; k < SET; k += 1) {
        var p = picks[k], paid = k < PAID;
        out += p
          ? '<div class="b3__slot is-on' + (k === freshAt ? ' is-new' : '') + '">' + shot(p, 240) +
            '<button type="button" class="b3__slot-x" data-b3-x="' + items.indexOf(p) + '" aria-label="× ' + esc(label(p)) + '">×</button>' +
            '<span class="b3__slot-n">' + esc(shortName(p)) + '</span>' +
            (paid ? '<span class="b3__slot-p">' + money(p.price) + '</span>'
                  : '<span class="b3__slot-p free"><s>' + money(p.price) + '</s>' + esc(t('free')) + '</span>') + '</div>'
          : '<div class="b3__slot"><span class="b3__slot-e"><span><b>+</b>' +
            esc(paid ? t('slotPaid', {i: k + 1}) : t('slotFree', {i: k - PAID + 1})) + '</span></span></div>';
      }
      // 3 or 6 slots sit on one row; 9 fit one row on desktop and 5 + 4 on a phone.
      [slots, pinSlots].forEach(function (box) {
        if (!box) return;
        box.classList.toggle('b3__slots--compact', SET > 3);
        box.style.gridTemplateColumns = 'repeat(' + (SET <= 6 || wideMq.matches ? SET : 5) + ',1fr)';
        box.innerHTML = out;
      });
    }
    setText('[data-b3-pin-left]', n && left ? t('stickyMore', {n: left}) : t('stepPaid', tv));
    var pinMsg = $('[data-b3-pin-msg]');
    if (pinMsg) {
      pinMsg.hidden = !st.msg;
      pinMsg.textContent = st.msg;
      pinMsg.classList.toggle('is-warn', st.warn);
    }
    var full = $('[data-b3-full]');
    if (full) {
      full.textContent = st.msg || (left === 0 ? t('full', tv) : n ? t('needMore', {n: left}) : '');
      full.classList.toggle('is-warn', st.warn);
    }

    var rows = $('[data-b3-rows]');
    if (rows) {
      var html = '';
      for (var r = 0; r < SET; r += 1) {
        var q = picks[r], isPaid = r < PAID;
        html += q
          ? '<div class="a__row">' + shot(q, 300) +
            // Every free design gets its own row: seeing them one by one is what makes the deal feel big.
            // The facts line stays on the 3-wallet set only, or 6 and 9 rows repeat it down the page.
            '<span class="what">' + esc(label(q)) + (SET <= 3 && kindOf(q).facts ? '<small>' + esc(kindOf(q).facts) + '</small>' : '') +
            (isPaid ? '' : '<span class="a__gift">' + esc(t('freeBadge')) + '</span>') + '</span>' +
            '<span class="amt">' + (isPaid ? money(q.price) : '<s>' + money(q.price) + '</s><span class="free">' + esc(t('free')) + '</span>') + '</span></div>'
          : '<div class="a__row a__row--empty"><span class="b3__ph"></span><span class="what">' +
            esc(isPaid ? t('rowPaid', {i: r + 1}) : t('rowFree', {i: r - PAID + 1})) + '<small>' + esc(t('rowHint')) + '</small></span><span class="amt"></span></div>';
      }
      if (OFF) html += '<div class="a__row a__row--bonus"><span class="b3__ph b3__ph--bonus">+</span><span class="what">' + esc(t('bonusRow', tv)) +
        '<small>' + esc(n >= SET ? t('bonusOn') : t('bonusWhen', tv)) + '</small></span><span class="amt">−' + moneyShort(OFF) + '</span></div>';
      rows.innerHTML = html;
    }
    var worth = picks.reduce(function (s, x) { return s + x.price; }, 0);
    var pay = priceOf(picks);
    setText('[data-b3-worth]', money(worth));
    setText('[data-b3-save]', (worth - pay > 0 ? '−' : '') + money(worth - pay));
    setText('[data-b3-pay]', money(pay));
    var tot = $('.a__total'); if (tot) tot.hidden = !n;
    var tip = $('[data-b3-tip]'); if (tip) { tip.hidden = !!n; tip.textContent = t('tip', tv); }

    var ready = left === 0;
    var up = $('[data-b3-up]'), nextT = TIERS[TIER + 1];
    if (up) {
      up.hidden = !(ready && nextT && !st.busy);
      if (!up.hidden) up.innerHTML = '<b>' + esc(t('upTitle', {n: nextT.n - SET, total: nextT.n})) + '</b><span>' +
        esc(t('upSub', {paid: nextT.paid, total: nextT.n, price: money(tierPrice(nextT))})) + '</span>';
    }
    var cta = st.busy ? t('adding') : ready ? t('ctaAdd') : t('ctaMore', {n: left});
    setText('[data-b3-cta-label]', cta);
    setText('[data-b3-sticky-label]', st.busy || ready ? cta : n ? t('stickyMore', {n: left}) : t('stickyStart', tv));
    $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.setAttribute('aria-disabled', String(!ready || st.busy)); });
    setText('[data-b3-sticky-p]', ready ? t('stickyPay', {price: money(pay)}) : t('stickyPrice', {set: SET, price: money(bestSetPrice())}));
    setText('[data-fw-sticky-sub]', n ? picks.map(function (x) { return x.n; }).join(' · ') : t('stickySubEmpty', tv));
  }

  function announce(msg) { var l = $('[data-fw-live]'); if (l) l.textContent = msg; }
  function say(msg, warn) { st.msg = msg; st.warn = !!warn; }
  function scrollTo(sel) { var el = $(sel); if (el) el.scrollIntoView({behavior: 'smooth', block: 'center'}); }

  function add(p) {
    // The set is always the shopper's last SET taps: once it is full, a new tap drops the oldest pick. Tapping a
    // design already in the set means "one more of these", so the oldest pick of a DIFFERENT design goes.
    var full = st.picks.length >= SET;
    var dropAt = -1;
    if (full) {
      for (var j = 0; j < st.picks.length; j += 1) { if (st.picks[j] !== p) { dropAt = j; break; } }
      if (dropAt < 0) { say(t('allSame', {set: SET, name: label(p)}), false); render(); return; }
    }
    var oldest = dropAt > -1 ? st.picks[dropAt] : null;
    if (p.stock && countOf(p) + 1 > p.stock) { say(t('onlyLeft', {n: p.stock, name: label(p)}), true); render(); return; }
    if (oldest) st.picks.splice(dropAt, 1);
    st.picks.push(p);
    st.fresh = p;
    var left = SET - st.picks.length;
    if (oldest) {
      var msg = t('swapped', {from: label(oldest), to: label(p)});
      say(msg, false); render(); announce(msg);
    } else {
      say('', false); render();
      announce(label(p) + ' ✓ ' + (left ? t('needMore', {n: left}) : t('full', tv)));
      // The set just became complete: bring the Add to cart into view (never on a swap).
      if (!left) setTimeout(function () { scrollTo('[data-fw-cta]'); }, 150);
    }
    st.fresh = null;
  }
  function removeOne(p) {
    var at = st.picks.lastIndexOf(p);
    if (at > -1) st.picks.splice(at, 1);
    say('', false); render();
  }

  root.addEventListener('click', function (e) {
    var f = e.target.closest('[data-b3-filter]');
    if (f) { st.filter = f.getAttribute('data-b3-filter'); render(); return; }
    var tb = e.target.closest('[data-b3-tier]');
    if (tb) { applyTier(Number(tb.getAttribute('data-b3-tier'))); say('', false); render(); announce(t('stepTitle', tv)); return; }
    if (e.target.closest('[data-b3-up]')) { applyTier(TIER + 1); say(t('upDone', tv), false); render(); scrollTo('[data-b3-slots]'); return; }
    var x = e.target.closest('[data-b3-x]');
    if (x) { removeOne(items[Number(x.getAttribute('data-b3-x'))]); return; }
    var c = e.target.closest('[data-b3-i]');
    if (!c) return;
    var item = items[Number(c.getAttribute('data-b3-i'))];
    if (e.target.closest('[data-lens]')) openSheet(item);
    else if (e.target.closest('[data-pick-only]')) add(item);
  });
  var moreBtn = $('[data-fw-more]');
  if (moreBtn) moreBtn.addEventListener('click', function () {
    st.showAll = true; render();
    var first = $$('[data-b3-grid] [data-b3-i]')[FIRST]; if (first) first.querySelector('button').focus({preventScroll: true});
  });

  function defaultAdd(lines) {
    return post('/cart/add.js', {items: lines}).then(function () {
      // Broadcast theme (Feratia): these two events refresh and open the cart drawer. Other themes: write a
      // window.PICKER_ADD adapter that does what the theme's own product form does (see cart-adapter-horizon.liquid).
      if (document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]')) {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
        document.dispatchEvent(new CustomEvent('theme:product:added', {bubbles: true}));
      } else {
        window.location.href = '/cart';
      }
    });
  }
  function addToCart(e) {
    if (st.busy) return;
    if (st.picks.length < SET) { say(t('finish', {n: SET - st.picks.length}), true); render(); scrollTo('[data-b3-slots]'); return; }
    st.busy = true; setError(''); render();
    var props = {};
    props[OFFER_PROP] = OFFER_KEY;
    // Tracking: landing page + the ad's UTM tags on every line, so each order can be traced to page, offer and ad.
    // _blessac_offer -> _blessac_lp, _blessac_offer_src (utm_source), _blessac_utm_campaign, _blessac_utm_content.
    var pre = OFFER_PROP.replace(/_offer$/, '');
    props[pre + '_lp'] = window.location.pathname;
    if (UTM.source) props[OFFER_PROP + '_src'] = UTM.source;
    if (UTM.campaign) props[pre + '_utm_campaign'] = UTM.campaign;
    if (UTM.content) props[pre + '_utm_content'] = UTM.content;
    // One tap = one set; the same design picked twice goes in as one line with quantity 2.
    var qty = {};
    st.picks.forEach(function (p) { qty[p.id] = (qty[p.id] || 0) + 1; });
    var lines = Object.keys(qty).map(function (id) { return {id: Number(id), quantity: qty[id], properties: props}; });
    var done = function () { st.busy = false; st.picks = []; say(t('added', tv), false); render(); };
    if (IS_PROTOTYPE) {
      setTimeout(function () { window.alert('Prototype: this would add to cart\n\n' + JSON.stringify(lines, null, 1)); done(); }, 300);
      return;
    }
    var run = typeof window.PICKER_ADD === 'function' ? window.PICKER_ADD(lines, e && e.currentTarget) : defaultAdd(lines);
    Promise.resolve(run).then(function () { setTimeout(done, 1200); }).catch(function (err) {
      st.busy = false; render();
      setError(err && err.status === 422 && err.message ? t('errStock', {msg: err.message}) : t('err'));
      scrollTo('[data-fw-err]');
    });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.ok) return j;
        throw {status: r.status, message: j.description || j.message || ''};
      });
    });
  }
  function setError(msg) { var el = $('[data-fw-err]'); if (el) el.textContent = msg; }
  $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.addEventListener('click', addToCart); });
  var onWide = function () { var n = firstCount(); if (n !== FIRST) { FIRST = n; render(); } };
  if (wideMq.addEventListener) wideMq.addEventListener('change', onWide); else if (wideMq.addListener) wideMq.addListener(onWide);

  // Sticky bar: shown once the shopper has scrolled past the top and no Add to cart is on screen.
  var sticky = $('[data-fw-sticky]');
  var ctas = $$('[data-fw-cta]');
  if (sticky && 'IntersectionObserver' in window && ctas.length) {
    sticky.inert = true;
    var seen = new Map(), stickyWas = false;
    var syncSticky = function () {
      var anyVisible = false;
      ctas.forEach(function (c) { var v = seen.get(c); if (v && v.visible) anyVisible = true; });
      var on = !anyVisible && window.scrollY > 500;
      sticky.classList.toggle('is-on', on); sticky.inert = !on; sticky.setAttribute('aria-hidden', String(!on));
      if (on !== stickyWas) {
        stickyWas = on;
        document.documentElement.classList.toggle('fw-sticky-on', on);
        document.documentElement.style.setProperty('--fw-sticky-h', sticky.offsetHeight + 'px');
      }
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, {visible: en.isIntersecting}); });
      syncSticky();
    });
    ctas.forEach(function (c) { io.observe(c); });
    window.addEventListener('scroll', syncSticky, {passive: true});
  }

  // Small copy of the slots, pinned under the theme header while the designs scroll. It takes no room in the page
  // (height 0), so showing it never moves the grid. The theme scrolls div.page-wrapper on desktop: listen with capture.
  (function pinSlots() {
    var pin = $('[data-b3-pin]'), zone = $('[data-b3-zone]');
    if (!pin || !zone) return;
    var box = pin.firstElementChild;
    var headerBottom = function () {
      var bottom = 0;
      document.querySelectorAll('.shopify-section-group-header-group, header-component, #header-group').forEach(function (h) {
        var pos = getComputedStyle(h).position, r = h.getBoundingClientRect();
        if ((pos === 'sticky' || pos === 'fixed') && r.height > 0 && r.top <= 1 && r.bottom > bottom) bottom = r.bottom;
      });
      return bottom;
    };
    var check = function () {
      var top = headerBottom(), z = zone.getBoundingClientRect();
      pin.style.top = top + 'px';
      var on = z.top <= top + 1 && z.bottom > top + box.offsetHeight + 120;
      if (on === pin.classList.contains('is-on')) return;
      pin.classList.toggle('is-on', on);
      pin.setAttribute('aria-hidden', String(!on));
      box.inert = !on;
    };
    box.inert = true;
    document.addEventListener('scroll', check, {passive: true, capture: true});
    window.addEventListener('resize', check);
    check();
  })();

  // ---------------------------------------------------------------- detail sheet (photos + facts + add)
  var sheet = document.createElement('dialog');
  sheet.className = 'fw__sheet';
  sheet.setAttribute('aria-label', 'Details');
  root.appendChild(sheet);
  function openSheet(p) {
    var k = kindOf(p);
    var photos = (p.imgs || []).slice(0, 7);
    var n = photos.length + 1;
    var slides = [shot(p, 900)].concat(photos.map(function (u) {
      return '<img src="' + esc(sized(u, 800)) + '" alt="' + esc(label(p)) + '" width="800" height="1000" loading="lazy" decoding="async">';
    }));
    var full = st.picks.length >= SET;
    sheet.innerHTML =
      '<div class="fw__sheet-hd"><span class="fw__sheet-kind">' + esc(k.label || '') + '</span>' +
      '<button type="button" class="fw__sheet-x" data-x aria-label="Close">×</button></div>' +
      '<div class="fw__sheet-galwrap">' +
        '<div class="fw__sheet-gal" data-g>' + slides.map(function (h) { return '<div class="fw__sheet-sl">' + h + '</div>'; }).join('') + '</div>' +
        '<span class="fw__sheet-n" data-n aria-live="polite">1 / ' + n + '</span>' +
        (n > 1 ? '<span class="fw__sheet-swipe" data-swipe aria-hidden="true">' + esc(t('swipe')) + '</span>' : '') +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--p" data-ap aria-label="Previous photo">‹</button>' +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--n" data-an aria-label="Next photo">›</button>' +
      '</div>' +
      '<div class="fw__sheet-dots" data-d>' + slides.map(function (_, i) { return '<button type="button" data-i="' + i + '"' + (i ? '' : ' aria-current="true"') + ' aria-label="Photo ' + (i + 1) + '"></button>'; }).join('') + '</div>' +
      '<div class="fw__sheet-b">' +
        '<div class="fw__sheet-row"><h3>' + esc(label(p)) + '</h3><span class="pr">' + money(p.price) + '</span></div>' +
        (p.note ? '<p class="note">' + esc(p.note) + '</p>' : '') +
        (k.sheet || k.facts ? '<p class="facts">' + esc(k.sheet || k.facts) + '</p>' : '') +
        '<button type="button" class="fw__sheet-pick" data-pick>' + esc(full ? t('sheetFull', tv) : t('sheetAdd', tv)) + '</button>' +
      '</div>';
    var g = sheet.querySelector('[data-g]'), d = sheet.querySelector('[data-d]'), cnt = sheet.querySelector('[data-n]'), sw = sheet.querySelector('[data-swipe]');
    var cur = function () { return Math.round(g.scrollLeft / Math.max(1, g.clientWidth)); };
    var go = function (i) { g.scrollTo({left: Math.max(0, Math.min(n - 1, i)) * g.clientWidth, behavior: 'smooth'}); };
    g.addEventListener('scroll', function () {
      var i = cur();
      Array.prototype.forEach.call(d.children, function (b, j) { b.setAttribute('aria-current', String(j === i)); });
      cnt.textContent = (i + 1) + ' / ' + n;
      if (sw && i > 0) sw.hidden = true;
    }, {passive: true});
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) go(Number(b.getAttribute('data-i'))); });
    sheet.querySelector('[data-ap]').addEventListener('click', function () { go(cur() - 1); });
    sheet.querySelector('[data-an]').addEventListener('click', function () { go(cur() + 1); });
    sheet.querySelector('[data-x]').addEventListener('click', closeSheet);
    sheet.querySelector('[data-pick]').addEventListener('click', function () { closeSheet(); add(p); });
    if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    document.documentElement.classList.add('fw-sheet-open');
  }
  function closeSheet() { if (sheet.close) sheet.close(); else sheet.removeAttribute('open'); }
  sheet.addEventListener('close', function () { document.documentElement.classList.remove('fw-sheet-open'); });
  sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });

  // Judge.me app blocks (e.g. "All reviews page") render 25 reviews at once (~18,000px on a phone): show the first
  // screenful and a button that opens the rest. Judge.me fills the block after load, so watch its height.
  $$('.fw__jm--app').forEach(function (box) {
    var MAX = 1400, btn;
    var clamp = function () {
      if (btn || box.scrollHeight <= MAX + 200) return;
      box.classList.add('is-clamped');
      btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'fw__more fw__jm-more'; btn.textContent = t('moreReviews');
      btn.addEventListener('click', function () { box.classList.remove('is-clamped'); btn.remove(); });
      box.insertAdjacentElement('afterend', btn);
    };
    if ('ResizeObserver' in window) new ResizeObserver(clamp).observe(box); else setTimeout(clamp, 4000);
  });

  // Top photo gallery: swipe, the arrows or a thumbnail.
  (function gallery() {
    var box = $('[data-fw-gal]');
    if (!box) return;
    var g = box.querySelector('[data-gal-track]'), slides = g.children, thumbs = box.querySelectorAll('[data-gal-to]');
    var prev = box.querySelector('[data-gal-prev]'), next = box.querySelector('[data-gal-next]'), at = 0;
    var centre = function (s) { return s.offsetLeft + s.offsetWidth / 2 - g.clientWidth / 2; };
    var go = function (i) { g.scrollTo({left: centre(slides[Math.max(0, Math.min(slides.length - 1, i))]), behavior: 'smooth'}); };
    var sync = function () {
      var best = 0, gap = Infinity;
      Array.prototype.forEach.call(slides, function (s, i) { var d = Math.abs(centre(s) - g.scrollLeft); if (d < gap) { gap = d; best = i; } });
      at = best;
      Array.prototype.forEach.call(thumbs, function (b, i) { if (i === at) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      prev.hidden = at === 0; next.hidden = at === slides.length - 1;
    };
    g.addEventListener('scroll', sync, {passive: true});
    prev.addEventListener('click', function () { go(at - 1); });
    next.addEventListener('click', function () { go(at + 1); });
    Array.prototype.forEach.call(thumbs, function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-gal-to'))); }); });
  })();

  (function designCount() {
    var el = $('[data-b3-all]');
    if (!el) return;
    var keys = (data.kinds || []).map(function (k) { return k.key; });
    var count = function (k) { return items.filter(function (p) { return p.kind === k; }).length; };
    el.textContent = t('allDesigns', {total: items.length, w: count(keys[0]), m: count(keys[1])});
  })();

  render();
})();
